import { useEffect, useState } from "react";
import { RotateCcw, Save, Gauge } from "lucide-react";
import { toast } from "sonner";
import { api, errorText } from "@/lib/api";
import { BandTuning } from "@/components/accuracy/BandTuning";
import "@/components/teamproj/TeamProjections.css";

const ORDER = ["A", "B", "C", "D", "E", "F"];

// Admin editor for the opponent-difficulty scoring factors (A hardest .. F easiest).
export function BandSettingsCard() {
  const [factors, setFactors] = useState(null);
  const [labels, setLabels] = useState({});
  const [defaults, setDefaults] = useState({});
  const [b2b, setB2b] = useState(0.9);
  const [b2bDefault, setB2bDefault] = useState(0.9);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/rotation-band-factors")
      .then((r) => { setFactors(r.data.factors); setLabels(r.data.labels); setDefaults(r.data.defaults); setB2b(r.data.b2b_factor); setB2bDefault(r.data.b2b_default); })
      .catch((e) => toast.error(errorText(e)));
  }, []);

  const save = async (values, b2bValue = b2b) => {
    setBusy(true);
    try {
      const r = await api.put("/rotation-band-factors", { factors: Object.fromEntries(ORDER.map((b) => [b, Number(values[b])])), b2b_factor: Number(b2bValue) });
      setFactors(r.data.factors); setB2b(r.data.b2b_factor);
      toast.success("Συντελεστές δυναμικότητας αποθηκεύτηκαν");
    } catch (e) { toast.error(errorText(e)); } finally { setBusy(false); }
  };

  const applySuggestions = async (suggested) => {
    const merged = { ...factors, ...suggested };
    await save(merged);
    toast.success(`Εφαρμόστηκαν προτάσεις auto-tuning σε ${Object.keys(suggested).length} band`);
  };

  if (!factors) return null;
  return (
    <div className="tp-root mt-6">
      <div className="tp-card" data-testid="band-settings-card">
        <h4><Gauge size={13} className="inline mr-1" />ΣΥΝΤΕΛΕΣΤΕΣ ΔΥΝΑΜΙΚΟΤΗΤΑΣ ΑΝΤΙΠΑΛΟΥ <small>(admin · πολλαπλασιαστής σκοραρίσματος ανά band A–F, από τα win odds)</small></h4>
        <div className="tv-vform tv-margins">{ORDER.map((b) => (
          <label key={b}><small>{b} · {labels[b]}</small>
            <input type="number" step="0.01" min="0.5" max="1.5" value={factors[b]}
                   onChange={(e) => setFactors({ ...factors, [b]: e.target.value })} data-testid={`band-factor-${b}`} /></label>
        ))}</div>
        <div className="tv-vform tv-margins" style={{ marginTop: 10 }}>
          <label><small>Back-to-back (πολλαπλασιαστής όλων των stats)</small>
            <input type="number" step="0.01" min="0.5" max="1" value={b2b}
                   onChange={(e) => setB2b(e.target.value)} data-testid="b2b-factor" /></label>
          <span className="tp-note" style={{ alignSelf: "center" }}>= ποινή −{Math.round((1 - Number(b2b)) * 100)}% σε αγώνα back-to-back</span>
        </div>
        <div className="tv-vactions">
          <button type="button" className="tv-vbtn primary" onClick={() => save(factors)} disabled={busy} data-testid="band-factors-save"><Save size={14} />{busy ? "Saving…" : "Αποθήκευση"}</button>
          <button type="button" className="tv-vbtn" onClick={() => { setB2b(b2bDefault); save(defaults, b2bDefault); }} disabled={busy} data-testid="band-factors-default"><RotateCcw size={14} />Προεπιλογές</button>
        </div>
        <p className="tp-note">A = αντίπαλος φαβορί (δυσκολότερος) → χαμηλότερο σκοράρισμα· F = αντίπαλος outsider (ευκολότερος) → υψηλότερο. Το B2B εφαρμόζεται και στο Rotation Model και στους κανόνες του x4.</p>
        <BandTuning onApply={applySuggestions} refreshKey={factors} />
      </div>
    </div>
  );
}
